import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  @Input() title: string = 'Confirm Action';
  @Input() message: string = 'Are you sure you want to proceed?';
  @Input() confirmText: string = 'Confirm';
  @Input() cancelText: string = 'Cancel';
  @Input() itemName?: string;
  @Input() isDangerous: boolean = false;
  @Input() confirmationText?: string; // Text user must type to confirm

  typedConfirmation: string = '';

  constructor(private modalCtrl: ModalController) {}

  get canConfirm(): boolean {
    if (!this.confirmationText) return true;
    return this.typedConfirmation === this.confirmationText;
  }

  async confirm() {
    if (!this.canConfirm) return;
    await this.modalCtrl.dismiss({ confirmed: true });
  }

  async cancel() {
    await this.modalCtrl.dismiss({ confirmed: false });
  }
}
